<template>
  <v-content class="">

    <section>
        <v-parallax
          :src="require('@/assets/beach-tsv2.jpg')"
          height="500"
          class="banner"
        >
          <Navbar></Navbar>

          <v-layout column class="white--text " justify-end>
            <div>
              <v-container justify-end>
                <div class=" display-1  mt-3 subpage-heading-1 ">
                  Frequently Asked Questions
                </div>
                <div class=" headline  mt-3 subpage-heading-2 ">
                  Learn about the Program!
                </div>
              </v-container>
            </div>
          </v-layout>
        </v-parallax>
      </section>

    <v-container grid-list-xl class=" white-background">
    <section>
      <v-container>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">Frequently Asked Questions</h2>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline  ">Before the Inspection</h2>
            </div>
          </v-flex>
        </v-layout>
        <template>
          <v-expansion-panels class="elevation-0">
            <v-expansion-panel
                    v-for="(item, i) in before"
                    :key="i"
            >
              <v-expansion-panel-header class="blue--text">{{ item.heading }}</v-expansion-panel-header>
              <v-expansion-panel-content>

                  {{ item.text
                  }}<a v-if="item.linked" :href="item.link">{{ item.linkText }}.</a>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline  ">During the Inspection</h2>
            </div>
          </v-flex>
        </v-layout>
        <template>
          <v-expansion-panels>
            <v-expansion-panel
                    v-for="(item, i) in during"
                    :key="i"
            >
              <v-expansion-panel-header class="blue--text">{{ item.heading }}</v-expansion-panel-header>
              <v-expansion-panel-content>

                  {{ item.text
                  }}<a v-if="item.linked" :href="item.link">{{ item.linkText }}.</a>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline" >After the Inspection</h2>
            </div>


          </v-flex>
        </v-layout>
        <template>
          <v-expansion-panels>
            <v-expansion-panel
                    v-for="(item, i) in after"
                    :key="i"
            >
              <v-expansion-panel-header class="blue--text">{{ item.heading }}</v-expansion-panel-header>
              <v-expansion-panel-content>

                  {{ item.text
                  }}<a v-if="item.linked" :href="item.link">{{ item.linkText }}.</a>

              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-container>
    </section>
    </v-container>

    <Footer></Footer>
  </v-content>
</template>

<script>
import { router } from "../router";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "Faq",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    before: [
        {
            heading: "Who is the Authorised Person?",
            text:
            "The Authorised Person is someone who has been voted in by the Body Corporate Committee to represent the property in the following:\n" +
            "\n" +
            " registering in the program, \n" +
            "\n" +
            " contact person for the property within the program, \n" +
            "\n" +
            " responsible for supplying and updating correct information regarding the property," +
            "\n" +
            " is the contact person for the inspector to arrange a time to undertake the inspection," +
            "\n" +
            " can appoint another person to be present during the inspection.",
            linked: false
        },
        {
          heading: "How do I register for the Program?",
          text:
              "The Authorised Person, voted in by the Body Corporate Committee, can register through the SIP Web Portal ",
          link: "https://stp.hpc.jcu.edu.au/#/registration",
          linkText: "here",
          linked: true
        },
        {
            heading: "What happens after registering?",
            text:
                "After successfully registering you will receive your login details within 2 business days. Use these details to login to the strata portal at the top right, enter details about your sites, and submit your sites for an inspection. ",
            linked: false
        },
        {
            heading: "What is the cost of the inspection and the report? Does government funding cover these costs?",
            text: "The inspection and the report are provided free of charge to Bodies Corporate under SIP. The actual cost of the inspection varies depending on the size and complexity of the property and buildings.",
            linked: false
        }

    ],
    during: [
        {
            heading: "How is storm tide exposure evaluated?",
            text: "Inspectors determine the storm tide exposure using the relevant local government storm tide maps. If the property is in a storm tide prone area, then the inspector calculates the level of basements, lowest habitable storey and swimming pools using on-line contour maps provided by the Queensland Government.",
            linked: false
        },
        {
            heading: "Does the inspection determine whether the building complies with the standards and codes in place at the time of construction?",
            text: "No. The inspection is not a structural inspection and cannot indicate whether the " +
            "building complies with a specific code, regardless of the age of the building.  " +
            "The scores provided in the report reflect the age of the building. The scores can be " +
            "increased if structural upgrades are undertaken. The report contains general information only about the estimated " +
            "resilience of your property to damage from weather events and should not be considered as a replacement for professional " +
            "advice specific to the strata property. Further detailed building inspections and assessments may be required " +
            "in some situations.",
            linked: false
        },
        {
            heading: "If a roof void cannot be accessed how is this handled i.e. do you remove some roof " +
            "sheets to verify condition of timber trusses, tie downs etc?",
            text: "No. Inspectors make a visual inspection only and are not able to lift roof cladding. " +
            "The inspection is a visual inspection that is limited to those areas and parts of the property " +
            "fully accessible and visible to the inspector at the time of the inspection. " +
            "The inspection does not involve any structural testing or removal of cladding. " +
            "The inspection does not involve any invasive inspection including cutting; breaking apart; dismantling; removing or " +
            "moving objects including, roofing, wall and ceiling sheeting, ducting, foliage, mouldings, debris, roof insulation, sarking, " +
            "and floor or wall coverings in order to inspect areas that are concealed or obstructed.",
            linked: false
        },
    ],
    after: [
        {
            heading: "What happens after the inspection?",
            text:
                "After the inspection, a report will be prepared and provided to the Authorised Person with the " +
                "score and recommendations. Click to see a sample report: ",
            linked: true,
            link: "https://www.jcu.edu.au/__data/assets/pdf_file/0009/1171395/NQSTIP_Sample_Report.pdf",
            linkText: "Sample Report"
        },
        {
            heading: "Who receives a copy of the report?",
            text:
                "After the inspection, the report will be provided to the Authorised Person.",
            linked: false
        },
        {
            heading:
                "Am I obligated to show my insurance company a copy of my report?",
            text:
            "Bodies Corporate should note that most insurance policies include a " +
            "          duty of disclosure that may require disclosing to the " +
            "          insurer the results of an inspection under this program, which may "  +
            "          affect future policies and/or premiums. Insurance companies take many factors " +
            "          into account when determining insurance policy coverage and premiums, " +
            "          this inspection may be an additional factor.",
            linked: false/*,
        link:
          "https://www.legislation.qld.gov.au/view/pdf/2017-07-03/act-1997-028",
        linkText: "Body Corporate and Community Management act 1997"*/
        },
        {
            heading: "Will you share my information with Insurers or others?",
            text:
            "We take your privacy seriously. We will not share your details, your reports or other associated information with anyone except the Authorised Person on your account.\n" +
            "\n" +
            "The undertaking of this Program is compliant with parts 1 and 3 of chapter 2 of the ",
            linked: true,
            link:
                "https://www.legislation.qld.gov.au/view/pdf/inforce/2017-06-05/act-2009-014",
            linkText: "Information Privacy Act 2009 (QLD)"
        },
        {
            heading: "If the Authorised Person has a question about the report, is it possible to discuss it with the inspector?",
            text:
                "It is not possible to discuss the report with the inspector. However, you can contact the SIP Program at the Cyclone Testing Station, James cook University and discuss the report with one of the members of the technical team. The technical team review the inspections and are in contact with the inspectors before the reports are issued, so they are aware of the features of the properties and can also explain how those features have contributed to the scores.",
            linked: false
        },
    ],
    items: [
      {
        heading: "How do I register for the Program?",
        text:
          "The Authorised Person, voted in by the Body Corporate Committee, can register through the Strata Title Web Portal ",
        link: "",
        linkText: "here",
        linked: true
      },
      {
        heading: "What happens after registering?",
        text:
          "After successfully registering you will receive your login details within 2 business days. Use these details to login to the strata portal at the top right, enter details about your sites, and submit your sites for an inspection. ",
        linked: false
      },
      {
        heading: "What happens after the inspection?",
        text:
          "After the inspection, a report will be prepared and provided to the Authorised Person with the score and recommended mitigation options.",
        linked: false
      },
      {
        heading: "Who receives a copy of the report?",
        text:
          "After the inspection, the report will be provided to the Authorised Person.",
        linked: false
      },
      {
        heading:
          "Am I obligated to show my insurance company a copy of my report?",
        text:
          "Bodies Corporate should note that most insurance policies include a " +
          "          duty of disclosure that may require disclosing to the " +
          "          insurer the results of an inspection under this program, which may "  +
          "          affect future policies and/or premiums. Insurance companies take many factors " +
          "          into account when determining insurance policy coverage and premiums, " +
          "          this inspection may be an additional factor.",
        linked: false/*,
        link:
          "https://www.legislation.qld.gov.au/view/pdf/2017-07-03/act-1997-028",
        linkText: "Body Corporate and Community Management act 1997"*/
      },
      {
        heading: "Will you share my information with Insurers or others?",
        text:
          "We take your privacy seriously. We will not share your details, your reports or other associated information with anyone except the Authorised Person on your account.\n" +
          "\n" +
          "The undertaking of this Program is compliant with parts 1 and 3 of chapter 2 of the ",
        linked: true,
        link:
          "https://www.legislation.qld.gov.au/view/pdf/inforce/2017-06-05/act-2009-014",
        linkText: "Information Privacy Act 2009(QLD)"
      },
      {
        heading: "Who is the Authorised Person?",
        text:
          "The Authorised Person is someone who has been voted in by the Body Corporate Committee to represent the property in the following:\n" +
          "\n" +
          " registering in the program, \n" +
          "\n" +
          " contact person for the property within the program, \n" +
          "\n" +
          " responsible for supplying and updating correct information regarding the property," +
          "\n" +
          " is the contact person for the inspector to arrange a time to undertake the inspection," +
          "\n" +
          " can appoint another person to be present during the inspection.",
        linked: false
      }
    ]
  }),
  methods: {
    gotoHome() {
      router.push("/");
    },
    gotoLogin() {
      router.push("/login");
    },
    gotoHelp() {
      router.push("/faq");
    }
  }
};
</script>
